import { getStoreInfo } from 'src/api/home';
import { getCategories } from 'src/api/list';
import { getStoreSEO } from 'src/api/common';
import { getCartTableId, setCartTableId } from 'src/utils/common';



export function prefetchStoreInfo({ commit }, { currentRoute, redirect }) {
  console.log('>>prefetchStoreInfo: currentRoute: ', currentRoute.path)
  if (currentRoute.path !== '/page/Error404') {
    console.log('>>prefetchStoreInfo: path not 404')
    const storeName = currentRoute.params.store;
    return new Promise((resolve, reject) => {
      console.log('>>StartFetchStoreInfo');
      getStoreInfo().then(res => {
        try {
          console.log('>>ThenFetchStoreInfoErr: ', res);
          const { data, success } = res || {};
          if (success && data && data?.id) {
            // 店铺状态为500跳转到404
            if (data?.status?.statusCode === 500) {
              redirect && redirect({ path: '/page/Error404' })
              return reject();
            }
            commit('updateStoreUrl', storeName);
            commit('updateStoreInfo', data);
            return resolve();
          }
          reject('NE');
          redirect && redirect({ path: '/page/Error404' });
        } catch (error) {
          console.log('>>THEN ERROR: ', error);
          redirect && redirect({ path: '/page/Error404' });
        }
      }).catch(e => {
        console.log('>>CatchFetchStoreInfoErr: ', e);
        reject('NE');
        redirect && redirect({ path: '/page/Error404' });
      }).finally(() => {
        console.log('>>ENDFetchStoreInfo')
      })
    })
  }
  return Promise.resolve();
}

export function prefetchSEO({ commit }, { currentRoute, redirect }) {
  if (currentRoute.path === '/page/Error404') {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    getStoreSEO().then(seo => {
      commit('updateStoreSEO', seo.data || {})
    }).catch(e => console.log(e)).finally(() => resolve())
  })
}

export function prefetchCategories({ commit, state }) {
  if (Array.isArray(state.categories) && state.categories.length) {
    return Promise.resolve();
  }
  return getCategories().then(res => {
    commit('updateCategories', res.data || []);
  })
}

export function getCartDetails({ state, commit }, cartData) {
  if (state.storeInfo.fullDineIn && process.env.CLIENT) {
    const { cartId, tableId } = getCartTableId();
    const { cartId: cid, tableId: tid, tableNumber } = cartData || {};
    if (!cartId && !tableId) {
      setCartTableId({ cartId: cid, tableId: tid });
    }
    // else if (cartId !== cid || tableId !== tid) {
    //   bus.$emit('SHOW_NEW_TABLE', tableNumber);
    // }
  }
  commit('updateCartDetailsData', cartData);
}
